import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";

import PageNotFound from "@/components/utils/PageNotFound";

import BrandLayout from "@/layouts/BrandLayout";

const AddNewBrand = lazy(() => import("@/pages/manager/brand/AddNewBrand"));
const BrandContactPage = lazy(
  () => import("@/pages/manager/brand/BrandContactPage"),
);
const BrandHomePage = lazy(() => import("@/pages/manager/brand/BrandHomepage"));
const BrandListingsPage = lazy(
  () => import("@/pages/manager/brand/BrandListingsPage"),
);
const  AccommodationRoutes = lazy(()=> import("./AccommodationRoutes"));
import GenericLoader from "@/components/ui/GenericLoader";
export default function BrandRoutes() {
  return (
    <Suspense fallback={<GenericLoader type={"page"} message={"Gathering brand accommodations"} />}>

    <Routes>
      <Route path="devchooser/new" element={<AddNewBrand />} />

      <Route element={<BrandLayout />}>
        <Route index element={<BrandHomePage />} />
        <Route path="listings" element={<BrandListingsPage />} />
        <Route path="contact" element={<BrandContactPage />} />
        <Route path="accommodations/*" element={<AccommodationRoutes />} />
      </Route>
      <Route path="*" element={<PageNotFound />} />
    </Routes>
    </Suspense>
  );
}
